<template>
  <div class="status-bar">
    <div v-if="$i18n.locale == 'en'">
      <div class="sorry-status-bar" data-status-bar-for="e31b0d77"></div>
    </div>
    <div v-if="$i18n.locale == 'fr'">
      <div class="sorry-status-bar" data-status-bar-for="8a17b9d2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusBar"
};
</script>

<style></style>
